<template>
  <div class="harzone-virtue harzone-offset">
    <div class="invcommonweb">
      <h3 v-if="title" class="harzone-title">{{title}}</h3>
      <div class="harzone-wrapper">
        <div class="virtue-slick">
          <div class="slick" v-for="(item, index) in data" :key="index">
            <a href="javascript:;">
              <div class="figure"><img :src="baseApi + item.image"  ></div>
              <div class="content">
                <h4 class="title">{{item.title}}</h4>
                <div v-if="item.text" class="text">{{item.text}}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
    const $ = window.$
    if ($('.virtue-slick').length) {
      $('.virtue-slick').slick({
        autoplay: false,
        draggable: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        speed: 300,
        infinite: false,
        prevArrow: "<span class='slick-button-prev virtue-slick-prev'></span>",
        nextArrow: "<span class='slick-button-next virtue-slick-next'></span>"
      })
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UsedList.vue